import React from 'react'
import { AgendaCard } from './AgendaCard.jsx'

const ACCENT = '#c4783b'

export function AgendaSection({
  sessionId,
  reportId,
  agenda,
  locked,
  currentUserId,
  otherUserName,
  onSaved,
}) {
  const items = agenda?.items || []
  const totalCount = agenda?.totalCount ?? items.length

  const summaryParts = []
  if (totalCount === 1) summaryParts.push('1 item')
  else if (totalCount > 0) summaryParts.push(`${totalCount} items`)

  return (
    <div style={styles.section}>
      {/* Section header */}
      <div style={styles.header}>
        <div style={styles.headerLeft}>
          <div style={styles.accentBar} />
          <div>
            <span style={styles.label}>Agenda</span>
            <span style={styles.subtitle}>shared between report and manager</span>
          </div>
        </div>
        {summaryParts.length > 0 && (
          <span style={styles.summary}>{summaryParts.join(' · ')}</span>
        )}
      </div>

      <AgendaCard
        sessionId={sessionId}
        reportId={reportId}
        initialItems={items}
        locked={locked}
        currentUserId={currentUserId}
        otherUserName={otherUserName}
        onSaved={onSaved}
      />
    </div>
  )
}

const styles = {
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    background: '#faf6f2',
    borderRadius: 10,
    padding: '14px 16px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 10,
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  accentBar: {
    width: 3,
    height: 20,
    borderRadius: 2,
    background: ACCENT,
    flexShrink: 0,
  },
  label: {
    fontSize: 12,
    fontWeight: 700,
    color: ACCENT,
    marginRight: 8,
  },
  subtitle: {
    fontSize: 11,
    color: 'var(--text-secondary)',
  },
  summary: {
    fontSize: 11,
    color: 'var(--text-secondary)',
    whiteSpace: 'nowrap',
  },
}
